<template>
  <div class="verification-platform">
    <header class="vp-header">
      <div class="vp-header__inner">
        <div class="vp-header__left">
          <div class="vp-header__logo-mark">中智</div>
          <div class="vp-header__company">
            <span class="vp-header__company-text">{{invoice.belongCompany}}</span>
          </div>
        </div>
        <div class="vp-header__actions">
          <button class="vp-header__primary-btn">
            官方唯一收据核验平台
          </button>
        </div>
      </div>
    </header>

    <main class="vp-main">
      <section class="vp-main__intro">
        <div class="vp-main__intro-inner">
          <h2 class="vp-main__intro-title">电子收据唯一核验平台</h2>
          <p class="vp-main__intro-desc">
            本平台为{{invoice.belongCompany}}官方指定的电子收据核验渠道，唯一且权威，保障您的核验结果真实有效
          </p>
          <div class="vp-main__intro-tags">
            <div class="vp-main__intro-tag">
              <span class="vp-main__intro-icon">✔</span>
              <span>官方认证</span>
            </div>
            <div class="vp-main__intro-tag">
              <span class="vp-main__intro-icon">✔</span>
              <span>唯一核验</span>
            </div>
            <div class="vp-main__intro-tag">
              <span class="vp-main__intro-icon">✔</span>
              <span>真实有效</span>
            </div>
            <div class="vp-main__intro-tag">
              <span class="vp-main__intro-icon">✔</span>
              <span>全程可溯</span>
            </div>
          </div>
        </div>
      </section>

      <section class="vp-main__content">
        <div
          class="vp-main__code-bar"
          :class="isSuccess ? 'vp-main__code-bar--success' : 'vp-main__code-bar--error'"
        >
          <div class="vp-main__code-left">
            <div class="vp-main__code-label">收据唯一核验码：</div>
            <div
              class="vp-main__code-value"
              :class="{ 'vp-main__code-value--invalid': !isSuccess }"
            >
              {{ displayCode }}
            </div>
          </div>
          <div
            class="vp-main__status-strip"
            :class="isSuccess ? 'vp-main__status-strip--success' : 'vp-main__status-strip--error'"
          >
            <span class="vp-main__status-circle">
              <span class="vp-main__status-check">✔</span>
            </span>
            <span class="vp-main__status-text">
              {{ isSuccess ? '核验通过 · 该收据为真实有效凭证' : '核验失败 · 该收据无效/已篡改' }}
            </span>
          </div>
        </div>

        <template v-if="isSuccess">
          <success-view class="vp-main__panel" :invoice="invoice"/>
          <!-- <div class="vp-main__statement-actions">
            <button type="button" class="vp-main__statement-btn vp-main__statement-btn--blue" @click="toggleStatusForDemo">切换为核验失败</button>
          </div> -->
        </template>
        
        <template v-else>
          <failure-view class="vp-main__panel" />
          <div class="vp-main__statement-actions">
            <button type="button" class="vp-main__statement-btn vp-main__statement-btn--danger" @click="toggleStatusForDemo">返回中智薪税云</button>
          </div>
        </template>
      </section>
    </main>
  </div>
</template>

<script>
import SuccessView from './Success.vue';
import FailureView from './FailureView.vue';
import { getReceiptInfo } from '@/api/payroll/payroll'

export default {
  name: 'ReceiptVerificationPlatform',
  components: {
    SuccessView,
    FailureView,
  },
  data() {
    return {
      invoice: {}
    }
  },
  computed: {
    isSuccess() {
      const status = (this.$route.query.status || '').toString().toLowerCase();
      if (['fail', 'failed', 'error', 'invalid'].includes(status)) {
        return false;
      }
      return true;
    },
    displayCode() {
      const code = this.$route.query.id || '暂无';
      return code;
    },
  },
  created(){
    this.init();
  },
  methods: {
    init(){
      getReceiptInfo(
        {
          randStr: this.$route.query.randStr ,
          id: this.$route.query.id
        }
      ).then(res => {
        console.log("res", res);
        if (res.data.code == 0) {
          if (res.data.data.checkStatus) {
            this.invoice = res.data.data
          } else {
            this.$router.replace({
              ...this.$route,
              query: {
                ...this.$route.query,
                status: 'fail',
              },
            });
          }
        } else {
          this.$message.error('暂时无法查验!去看看中智薪税云吧!')
          this.$router.push({path: '/login'})
        }
      }).catch(error => {
        console.log("error", error);

      })
    },
    toggleStatusForDemo() {
      this.$router.push({path: '/login'})
      // const nextStatus = this.isSuccess ? 'fail' : 'success';
      // this.$router.replace({
      //   ...this.$route,
      //   query: {
      //     ...this.$route.query,
      //     status: nextStatus,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.verification-platform {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f2eee7;
  color: #333;
  font-size: 14px;
  padding-bottom: 42px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.vp-header {
  background: #013f8a;
  color: #fff;
  padding: 12px 24px;

  .vp-header__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .vp-header__left {
    display: flex;
    align-items: center;
    flex: 5;
  }

  .vp-header__logo-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background: #fff;
    color: #013f8a;
    font-weight: 600;
    margin-right: 10px;
  }
  
  /* 允许公司名称换行 */
  .vp-header__company-text {
    white-space: normal;
    overflow-wrap: anywhere;   /* 长词/数字也能断行 */
    word-break: break-word;
  }
  
  /* 允许按钮文案换行 */
  .vp-header__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 4;
    .vp-header__primary-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      min-width: 150px;
      height: 40px;
      padding: 4px 18px;
      border-radius: 20px;
      border: none;
      background: #ff8b00;
      color: #fff;
      cursor: pointer;
      font-size: 13px;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: break-word;
      line-height: 1.4;
    }
  }
}

.vp-main {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vp-main__intro {
  width: 100%;
  max-width: 1200px;
}

.vp-main__intro-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 18px 24px 14px;
  text-align: center;
  color: #1a3f8a;
  position: relative;
}

.vp-main__intro-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;
}

.vp-main__intro-desc {
  margin: 0 auto 10px;
  max-width: 720px;
  font-size: 13px;
  color: #999;
}

.vp-main__intro-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 4px;
  padding-bottom: 8px;
}

.vp-main__intro-inner::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  height: 0;
  border-bottom: 2px solid #013f8a;
}

.vp-main__intro-tag {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  color: #013f8a;
}

.vp-main__intro-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #013f8a;
  background-color: #013f8a;
  color: #ffffff;
  font-size: 12px;
  margin-right: 4px;
}

.vp-main__content {
  width: 100%;
  max-width: 1200px;
  margin-top: 20px;
}

.vp-main__code-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  padding: 12px 20px;
  border-radius: 10px;
  border-left-width: 4px;
  border-left-style: solid;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.vp-main__code-bar--success {
  border-left-color: #00a451;
  background-color: #ffffff;
}

.vp-main__code-bar--error {
  border-left-color: #e84134;
  background-color: #ffffff;
}

.vp-main__code-left {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  row-gap: 4px;
}

.vp-main__code-label {
  color: #333;
  margin-right: 6px;
  font-weight: 500;
}

.vp-main__code-value {
  font-weight: 600;
  color: #f28b2a;
  letter-spacing: 1px;
}

.vp-main__code-value--invalid {
  text-decoration: line-through;
  text-decoration-thickness: 1px;
}

.vp-main__status-strip {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  font-size: 13px;
}

.vp-main__status-strip--success {
  color: #00924a;
}

.vp-main__status-strip--error {
  color: #e84134;
}

.vp-main__status-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: currentColor;
}

.vp-main__status-check {
  font-size: 14px;
  color: #ffffff;
  line-height: 1;
}

.vp-main__status-text {
  line-height: 1;
}

.vp-main__panel {
  margin-top: 16px;
}

.vp-main__statement-actions {
  display: flex;
  justify-content: flex-end;
  position: fixed;
  right: 12px;
  bottom: 16px;
}

.vp-main__statement-btn {
  padding: 8px 24px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
}

.vp-main__statement-btn--blue {
  background: #013f8a;
  color: #ffffff;
}

.vp-main__statement-btn--danger {
  background: #cb332b;
  color: #ffffff;
}

@media (max-width: 768px) {
  .vp-header {
    padding: 10px 12px;
  }

  .vp-header__inner {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .vp-header__actions {
    margin-left: auto;
  }

  .vp-header__company-text {
    white-space: normal;
  }

  .vp-header__primary-btn {
    white-space: normal;
    line-height: 1.4;
    padding: 6px 14px;
  }

  .vp-main {
    padding: 12px;
  }

  .vp-main__intro-inner {
    padding: 10px 12px 10px;
  }

  .vp-main__intro-title {
    font-size: 18px;
  }

  .vp-main__intro-desc {
    font-size: 12px;
  }

  .vp-main__content {
    padding: 16px 12px;
  }

  .vp-main__code-bar {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;
  }

  .vp-main__status-strip {
    white-space: normal;
  }
}
</style>

